import { FontSizes, makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: '20px !important',
  },
  commentContainer: {
    padding: 10,
    backgroundColor: theme.palette.neutralLighterAlt,
    width: 250,
    borderRadius: 4,
  },
  businessPurposeContainer: {
    marginTop: '30px !important',
  },
  leftInputsContainer: {
    flexBasis: '60%',
  },
  rightInputsContainer: {
    flexBasis: '40%',
  },
  totalAmount: {
    fontSize: FontSizes.size24,
  },
  workgroupContainer: {
    marginTop: 10,
  },
  travelAgencyContainer: {
    width: '50%',
  },
}));
